import { priorityNames } from './constants'

export const toPrioritiesSelect = () => {
  return priorityNames.map(priorityName => ({
    label: priorityName,
    value: priorityName.toLowerCase()
  }))
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toStatusesSelect = statuses =>
  statuses.map(status => ({
    value: status.id,
    label: status.name
  }))
